module.exports = __webpack_public_path__ + "74b51fcdb1d65985c5b05a04753d2a99.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-5.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-5.jpg
// module chunks = 40